import { createSlice, createAsyncThunk, bindActionCreators, Dispatch } from '@reduxjs/toolkit'
import { memsourceInitialFilterState } from '../../../config/memsourceInitialFilterState'
import { Prefix } from '../../interfaces/Prefix'
import { enumKeys } from '../../../helpers/functions/enumUtils'
import { filtersActions } from '../filters/filters'
import { pageActions } from '../page/page'
import { pageSizeActions } from '../pageSize/pageSize'
import { sortActions } from '../sort/sort'
import { projectsActions } from '../projects/projects'
import { currentProjectActions } from '../currentProject/currentProject'

const initialState = {
    filters: memsourceInitialFilterState,
    scrolling: false,
    loading: false,
    error: null,
}

export const resetAllStores = (dispatch: Dispatch) => {
    for (const prefix of enumKeys(Prefix)) {
        if (isNaN(Number(prefix))) {
            const resetFilters = bindActionCreators(filtersActions(prefix).resetFilters, dispatch)
            const resetPage = bindActionCreators(pageActions(prefix).resetPage, dispatch)
            const resetPageSize = bindActionCreators(pageSizeActions(prefix).resetPageSize, dispatch)
            const resetSort = bindActionCreators(sortActions(prefix).resetSort, dispatch)
            const resetProjects = bindActionCreators(projectsActions(prefix).resetProjects, dispatch)
            const resetCurrentProject = bindActionCreators(currentProjectActions(prefix).resetCurrentProject, dispatch)
            resetFilters()
            resetPage()
            resetPageSize()
            resetSort()
            resetProjects()
            resetCurrentProject()
        }
    }
}

export const login = createAsyncThunk('session/login', async (payload, { dispatch }) => {
    // TODO: move API call here
    resetAllStores(dispatch)
})

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        logout: () => ({ ...initialState }),
    },
    extraReducers: (builder) => {
        // login reducer
        builder.addCase(login.pending, (state) => ({ ...state, loading: true, error: null }))
        builder.addCase(login.fulfilled, (state) => ({
            ...state,
            loading: false,
            error: null,
        }))
        builder.addCase(login.rejected, (state, action) => ({
            ...state,
            loading: false,
            error: action.error,
        }))
    },
})

export default sessionSlice.reducer

export const logout = () => (dispatch: Dispatch): void => {
    sessionStorage.clear()
    resetAllStores(dispatch)
    dispatch(sessionSlice.actions.logout())
}
